
import color from "../../../../../constants/color";

const style = {
  card: {
    mt: 2,
    backgroundColor: "#fff",
    padding: "10%",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center  ",
    justifyContent: "space-Between"
  },
  dateCard: {
    mt: 2,
    backgroundColor: "#fff",
    padding: "4%",
    borderRadius: "20px",
    display: { xs: "block", md: "flex" },
    alignItems: "center  ",
    justifyContent: "space-Between"
  },

  inputSection: {
    display: { sx: "block", md: "flex" },
    justifyContent: "space-between",
    px: 2
  },

  inputBox: {
    width: { xs: "100%", md: "49%", lg: "31%" }
  },
  inputText: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1
  },

  dateInput: {
    width: "100%",
    my: 1,


    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }
  },
  tableHead: {
    color: "#878787",
    fontWeight: "400",
  },

  leaveHeading: {
    fontWeight: 600,
    fontSize: "20px",
  },


  checkinBtn: {
    "& svg": {
      mr: 1,
    },
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    px: 2,
    backgroundColor: "#28AA4A",
    color: "white !important",
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow: "none",
    "&:hover": {
      color: 'white !important',
    }
  },
  checkinBtns: {
    "& svg": {
      mr: 1,
    },
    borderLeft: '1px solid #fff',
    borderBottomRightRadius: 50,
    borderTopRightRadius: 50,
    backgroundColor: "#28AA4A",
    color: "#fff",
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow: "none",
  },
  mainGrid: {
    px: "15px",
    pt: "20px",
    display: { xs: "block", md: "flex" },
    justifyContent: "space-between",
    alignItems: "center",
  },
  textGrid: {
    display: "flex",
    justifyContent: { xs: "start", md: "end" },
    alignItems: { xs: "start", md: "end" },
    mt: { xs: 2, md: 0 },
  },
  whiteSection: {
    backgroundColor: color.card,
    m: 2,
    borderRadius: "20px",
  },
  csvBtns: {
    "& svg": {
      mr: 1,
    },
    borderBottomLeftRadius: 50,
    borderTopLeftRadius: 50,
    px: 1,
    backgroundColor: color.card,
    color: color.text,
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow: "none",
  },
  downloadBtns: {
    "& svg": {
      mr: 1,
    },
    borderBottomLeftRadius: 50,
    borderTopLeftRadius: 50,
    px: 2,
    backgroundColor: color.card,
    color: color.text,
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow: "none",
    "&:hover": {
      color: 'white !important',
    }
  },
  paidButton: {
    "& svg": {
      mr: 1,
    },
    mr: 2,
    borderRadius: 50,
    px: 3,
    color: "#fff",
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow: "none",
    backgroundColor: "#28AA4A"

  },

  inputGrids: {
    width: "100%"
  },
  table: {
    width: "100%",
    borderCollapse: "collapse" // optional, makes it look cleaner
  },
  paymentSection: {
    backgroundColor: color.card,
    m: 2,
    marginBottom: '-20px',
    borderRadius: "15px",
    p: 3
  },
  paymentTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 1
  },
  dropDownButton: {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer"
  },
  paymentHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
  },
  paymentTitle: {
    height: '24px',
    opacity: 1,
    fontWeight: 600,
    fontSize: '16px',
    color: '#202020',
  },
  paymentCount: {
    width: '26px',
    height: '26px',
    opacity: 1,
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '16px',
    fontStyle: 'normal', // 'SemiBold' is not valid; use weight
    lineHeight: '100%',
    letterSpacing: 0,
    backgroundColor: '#00ABF417',
    color: '#00ABF4', // assumed for contrast
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableHeader: {
    opacity: 1,
    color: '#878787',
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: '14px',
    textAlign: 'left',
    padding: '8px 12px',
  },
  tableCell: {
    fontWeight: 400,
    textAlign: 'left',
    fontSize: '14px',
    color: 'black',
    padding: '8px 12px',
    borderBottom: "none !important",
  },
  tableCellButton: {
    fontWeight: 400,
    textAlign: 'left',
    fontSize: '14px',
    color: 'black',
    padding: '8px 0px',
    borderBottom: "none !important",
  },
  actionButton: {
    minWidth: "32px",
    width: "32px",
    height: "32px",
    p: 0,
    borderRadius: "50%"
  },
  actionMenu: {
    backgroundColor: "#fff",
    boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
    borderRadius: "8px",
    mt: 1
  },
  labels: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    my: "10px"
  },
  labels2: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,

  },
  hoursInput: {
    border: "1px solid #E5E5E5 !important",
    width: "100%",
    borderRadius: "8px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
      borderRadius: "8px",

    },
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px",

    },

  },




}
export default style;